import LOOKER_ACTIONS from '../../../features/lrs/shared/lrsActionsConstant';

const {
    PM_GRAPH_ZOOM_EVENT,
    PM_GRAPH_RESET_ZOOM_EVENT,
    PROBE_DETAIL_VISITING_EVENT,
    PERCENTILE_EVENT,
    SELECT_INDIVIDUAL_STUDENT,
    DOWNLOAD_STUDENT_ACTIVITY,
    SORT_STUDENTS_BY_NAME,
    SEE_ACTIVITIES,
    HELP_DETAILS,
    DOWNLOAD_ALL_ACTIVITIES,
    OBSERVATION_SELECT,
    SELECT_PAGE,
    SELECT_SKILL,
    DOWNLOAD_ACTIVITY,
    SWITCH_INSTRUCTION_TAB,
    SELECT_HELP_ITEM,
    PRINT_CURRENT_PAGE,
    DOWNLOAD_PDF_LANGUAGE_CONSIDERATION,
    SWITCH_PROGRESS_TAB,
    SWITCH_LANGUAGE_CONSIDERATIONS_TAB,
    SELECTED_HEADER_DROPDOWN,
    PROGRESS_GOAL_SET_EVENT,
} = LOOKER_ACTIONS;

const probeDetailLookerEvent = (measure, studentId, currentSubtab) => ({
    type: PROBE_DETAIL_VISITING_EVENT,
    measure,
    studentId,
    currentSubtab,
});

export const pmGraphZoomEvent = (measure, studentId) => ({
    type: PM_GRAPH_ZOOM_EVENT,
    measure,
    studentId,
});

export const pmGraphResetZoomEvent = (measure, studentId) => ({
    type: PM_GRAPH_RESET_ZOOM_EVENT,
    measure,
    studentId,
});

export const percentileLookerEvent = value => ({
    type: PERCENTILE_EVENT,
    value,
});

export const selectIndividualStudent = (studentId, group) => ({
    type: SELECT_INDIVIDUAL_STUDENT,
    studentId,
    group,
});

export const downloadStudentActivity = (
    activityName,
    instructionalActivityId,
    studentId,
    ...otherProps
) => ({
    type: DOWNLOAD_STUDENT_ACTIVITY,
    activityName,
    instructionalActivityId,
    studentId,
    ...otherProps,
});

export const sortStudentByName = sortDirection => ({
    type: SORT_STUDENTS_BY_NAME,
    sortDirection,
});

export const seeActivitiesToggle = (collapsed, group) => ({
    type: SEE_ACTIVITIES,
    collapsed,
    group,
});

export const downloadAllActivities = (location, activities, group) => ({
    type: DOWNLOAD_ALL_ACTIVITIES,
    location,
    activities,
    group,
});

export const helpIconClick = (name, category, assessment, studentId, group) => ({
    type: HELP_DETAILS,
    name,
    category,
    assessment,
    studentId,
    group,
});

export const observationSelect = (checked, name, category, assessment, studentId, group) => ({
    type: OBSERVATION_SELECT,
    checked,
    name,
    category,
    assessment,
    studentId,
    group,
});

export const selectPage = (clickedItem, activityIds, pagesList, group) => ({
    type: SELECT_PAGE,
    item: clickedItem,
    activityIds,
    pagesList,
    group,
});

export const selectSkill = (skill, grade) => ({
    type: SELECT_SKILL,
    skill,
    grade,
});

export const downloadActivity = (instructionalActivityId, skill, grade) => ({
    type: DOWNLOAD_ACTIVITY,
    skill,
    grade,
    instructionalActivityId,
});

export const switchInstructionTabLrs = (tabName, group) => ({
    type: SWITCH_INSTRUCTION_TAB,
    tabName,
    group,
});

export const lrsSelectHelpItemEvent = title => ({
    type: SELECT_HELP_ITEM,
    payload: { title },
});

export const lrsPrintCurrentPageEvent = ({ documentKey, pdfInHeader }) => ({
    type: PRINT_CURRENT_PAGE,
    payload: { documentKey, pdfInHeader },
});

export const lrsLanguageConsiderationPdfDownload = ({ activityId, title, group }) => ({
    type: DOWNLOAD_PDF_LANGUAGE_CONSIDERATION,
    payload: { activityId, title, group },
});

export const lrsSwitchProgressTab = ({ selectedTab, selectedPeriod }) => {
    return {
        type: SWITCH_PROGRESS_TAB,
        selectedPeriod,
        selectedTab,
    };
};

export const switchLanguageConsiderationsTabLrs = (tabName, group) => ({
    type: SWITCH_LANGUAGE_CONSIDERATIONS_TAB,
    tabName,
    group,
});

export default probeDetailLookerEvent;

export const selectedHeaderDropdownEvent = ({
    dropdownName,
    classe,
    district,
    school,
    nameShown,
    nameList,
    nameSelected,
}) => ({
    type: SELECTED_HEADER_DROPDOWN,
    payload: { dropdownName, classe, district, school, nameShown, nameList, nameSelected },
});

export const progressGoalSetLookerEvent = ({
    selectedPeriod,
    measure,
    goalScore,
    prevGoalScore,
    growthRatePrev,
}) => ({
    type: PROGRESS_GOAL_SET_EVENT,
    selectedPeriod,
    measure,
    goalScore,
    prevGoalScore,
    growthRatePrev,
});
